import { Alert } from 'react-bootstrap';
import { FaTriangleExclamation } from 'react-icons/fa6';

import { useLocalGetEndpoint } from '../utils/fetching';
import { CITATION_FORMAT_REFERENCE } from './endpoint';
import { Reference } from './Reference';

export interface DOILoadReferenceProps {
  doi: string;
  copy?: boolean;
}

export function DOILoadReference({ doi, copy }: DOILoadReferenceProps) {
  const reference = useLocalGetEndpoint({
    endpoint: CITATION_FORMAT_REFERENCE,
    params: {
      doi,
      lang: 'en-US',
      style: 'apa',
    },
  });

  if (!reference) {
    return (
      <>
        <Alert variant="warning" className="d-flex align-items-center p-2">
          <FaTriangleExclamation className="me-2" />
          Could not get reference.
        </Alert>
        <a href={doi} target="_blank" rel="noopener noreferrer">
          {doi}
        </a>
      </>
    );
  }

  return <Reference reference={reference} copy={copy} />;
}
